/**
 * Очистка кэша приложения (Service Worker + Cache API) и перезагрузка.
 * Помогает пользователю получить свежую версию после деплоя.
 */

import { devWarn } from './devLog';

export async function clearAppCacheAndReload(): Promise<void> {
  if ('caches' in window) {
    try {
      const names = await caches.keys();
      await Promise.all(names.map((name) => caches.delete(name)));
    } catch (e) {
      devWarn('[clearAppCache] caches.delete failed:', e);
    }
  }
  if ('serviceWorker' in navigator) {
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    } catch (e) {
      devWarn('[clearAppCache] SW unregister failed:', e);
    }
  }
  const url = new URL(window.location.href);
  url.searchParams.set('vup', Date.now().toString());
  window.location.replace(url.toString());
}
